import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/link";

export const GET_NOTIFICATIONS = `
    user_notifications (search_term: $search, limit: $limit, page: $page) {
        data {
            id
            title
                body
            is_read
            created_at
            user {
                id
                first_name
                last_name
			}
			options
        },
        total,
        per_page
    }
`;

const GET_NOTIFICATION = `
	user_notification (id: $id) {
		id
		title
		body
		options
		is_read
		updated_at
		user {
			id
			first_name
			last_name
		}
	}
`;

const GET_NOTIFICATION_SETTINGS = `
	notification_settings {
		group_name
		items {
			name
			key_email
			send_email
			key_notification
			send_notification
		}
	}
`;

export const GET_UNREAD_NOTIFICATIONS = `
	unread_notifications
`;

export const MARK_ALL_READ = `read_notification(ids: $listIds)`;

export const DELETE_NOTIFICATIONS = `delete_notifications(ids: $ids)`;

export default {
	init() {},

	fetchNotifications(payload) {
		const queryOptions = {
			query: gql`query Notifications ($limit: Int!, $page: Int!, $search: String!) {
				${GET_NOTIFICATIONS}
			}`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				search: payload.search || ""
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				notifications: response.data.user_notifications
			};
		});
	},

	fetchUnreadNotifications() {
		const queryOptions = {
			query: gql`query UnreadNotifications {
				${GET_UNREAD_NOTIFICATIONS}
			}`
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				unread_notifications: response.data.unread_notifications
			};
		});
	},

	markReadNotifications(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation MarkAllReadNotifications ($listIds: [Int]) {
							${MARK_ALL_READ}
						}
					`,
				variables: {
					listIds: payload.listIds
				}
			})
			.then(response => {
				return { read_notification: response.data.read_notification };
			});
	},

	deleteNotifications(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteNotifications ($ids: [Int]) {
							${DELETE_NOTIFICATIONS}
						}
					`,
				variables: {
					ids: payload.listIds
				}
			})
			.then(response => {
				return { delete_notifications: response.data.delete_notifications };
			});
	},

	getDetailNotification(payload) {
		const queryOptions = {
			query: gql`query Notification ($id: Int!) {
				${GET_NOTIFICATION}
			}`,
			variables: {
				id: payload.id
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				notifications: response.data.user_notification
			};
		});
	},

	fetchNotificationSettings() {
		const queryOptions = {
			query: gql`query NotificationSettings {
				${GET_NOTIFICATION_SETTINGS}
			}`
		};

		return graphqlClient.query(queryOptions).then(response => response.data.notification_settings);
	},
};
